import {
  Box,
  Button,
  Step,
  StepLabel,
  Stepper,
  MenuItem,
  Select,
  InputLabel,
  Typography,
  TextField,
  FormControl,
  ListItemText,
  Checkbox,
  OutlinedInput,
  IconButton,
  Tooltip,
  Divider,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete"; // Import delete icon
import AddCircleIcon from "@mui/icons-material/AddCircle";
import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid2";
import { styled, useTheme } from "@mui/material/styles";
import courtValues from "./Json/courtValues.json";
import { baseUrl } from "../../environment";
import { axiosInstance } from "../../axiosInstance";
import Editor from "../Constants/editor";

const steps = [
  "Get Started",
  "Subsequent questions",
  "Relevant Cases",
  "Relevant Statutes",
  "Statement of Case",
  "Summary of Argument",
  "Argument",
  "Conclusions",
];

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function LegalAssistant() {
  // base url
  //
  // step Get Started
  const [title, setTitle] = useState("");
  const [userQuery, setUserQuery] = useState("");
  const [legalGroundsOrKeyArea, setLegalGroundsOrKeyArea] = useState("");
  const [courtByLaw, setCourtByLaw] = React.useState("");
  const [selectedCourt, setSelectedCourt] = useState([]);
  const [courtsToInclude, setCourtsToInclude] = React.useState([]);
  const [represent, setRepresent] = useState("");
  const [isObjectiveAnalysis, setIsObjectiveAnalysis] = React.useState(false);
  // End

  // Step 2
  const [answers, setAnswers] = useState({});
  const [questions, setQuestions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState({});
  const [editingQuestion, setEditingQuestion] = useState(null);

  //

  // step 1
  const [getStartedEditorData, setGetStartedEditorData] = useState("");

  const handleData = (data) => {
    setGetStartedEditorData(data);
  };
  //End

  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [courtOptions, setCourtOptions] = useState([]);
  const [courtIncludeOptions, setCourtIncludeOptions] = useState([]);

  // Step 3
  const [relevantCases, setRelevantCases] = useState({});
  //

  const handleCourtByLawChange = (event) => {
    const selectedCourtLaw = event.target.value;
    setCourtByLaw(selectedCourtLaw);

    // Update court options based on the selected court type
    if (selectedCourtLaw === "state_courts") {
      const options = Object.keys(courtValues.state_courts).map((state) => ({
        label: state.toUpperCase().replace(/_/g, " "),
        value: courtValues.state_courts[state].id,
        courts: courtValues.state_courts[state].courts,
      }));
      setCourtOptions(options);
    } else if (selectedCourtLaw === "federal_courts") {
      const options = Object.keys(courtValues.federal_courts).map((circuit) => {
        const federalCourt = courtValues.federal_courts[circuit];

        return {
          label: circuit.toUpperCase().replace(/_/g, " "),
          value: federalCourt?.court_of_appeals || federalCourt,
          courts: federalCourt?.courts || {},
        };
      });
      setCourtOptions(options);
    } else {
      // Handle unexpected values
      console.warn(`Unexpected court law selected: ${selectedCourtLaw}`);
      setCourtOptions([]); // or some default value
    }
  };

  const handleCourtByLawChangeWheStoreToLocalStorage = (value) => {
    const selectedCourtLaw = value;
    setCourtByLaw(selectedCourtLaw);

    // Update court options based on the selected court type
    if (selectedCourtLaw === "state_courts") {
      const options = Object.keys(courtValues.state_courts).map((state) => ({
        label: state.toUpperCase().replace(/_/g, " "),
        value: courtValues.state_courts[state].id,
        courts: courtValues.state_courts[state].courts,
      }));
      setCourtOptions(options);
    } else if (selectedCourtLaw === "federal_courts") {
      const options = Object.keys(courtValues.federal_courts).map((circuit) => {
        const federalCourt = courtValues.federal_courts[circuit];

        return {
          label: circuit.toUpperCase().replace(/_/g, " "),
          value: federalCourt?.court_of_appeals || federalCourt,
          courts: federalCourt?.courts || {},
        };
      });
      setCourtOptions(options);
    } else {
      // Handle unexpected values
      console.warn(`Unexpected court law selected: ${selectedCourtLaw}`);
      setCourtOptions([]); // or some default value
    }
  };

  const handleCourtChange = (values) => {
    const currentStateOfMultiSelect = [];
    values?.target?.value.forEach((element) => {
      currentStateOfMultiSelect.push(element);
    });

    setSelectedCourt(currentStateOfMultiSelect);

    // const courtKey = courtByLaw;

    if (courtByLaw === "state_courts") {
      const options = values?.target?.value.reduce((acc, value) => {
        const selectedState = Object.keys(courtValues.state_courts).find(
          (state) => courtValues.state_courts[state].id === Number(value)
        );

        if (selectedState) {
          const courts = Object.keys(
            courtValues.state_courts[selectedState].courts
          ).map((court) => ({
            label: court.toUpperCase().replace("_", " "),
            value: courtValues.state_courts[selectedState].courts[court],
          }));
          return [...acc, ...courts];
        }
        return acc;
      }, []);

      setCourtIncludeOptions(options);
    }
    //else if (Number(values?.target?.value.join(","))) {
    //   setCourtIncludeOptions(null);
    // }
    //  else if (values?.target?.value.join(",").includes("courts")) {
    else if (courtByLaw === "federal_courts") {
      const federalOptions = values?.target?.value.reduce((acc, value) => {
        const courtsOpt = Number(values?.target?.value)
          ? null
          : values?.target?.value.split("-");

        if (courtsOpt) {
          const items = Object.keys(
            courtValues[courtByLaw][courtsOpt[0]][courtsOpt[1]]
          ).map((item) => ({
            label: item.toUpperCase().replace("_", " "),
            value: courtValues[courtByLaw][courtsOpt[0]][courtsOpt[1]][item],
          }));
          return [...acc, ...items];
        }
        return acc;
      }, []);

      setCourtIncludeOptions(federalOptions);
    }
  };

  const handleCourtChangeWhenStoreInLocalStorage = (values) => {
    const currentStateOfMultiSelect = [];
    values.forEach((element) => {
      currentStateOfMultiSelect.push(element);
    });

    setSelectedCourt(currentStateOfMultiSelect);

    // const courtKey = courtByLaw;

    if (courtByLaw === "state_courts") {
      const options = values.reduce((acc, value) => {
        const selectedState = Object.keys(courtValues.state_courts).find(
          (state) => courtValues.state_courts[state].id === Number(value)
        );

        if (selectedState) {
          const courts = Object.keys(
            courtValues.state_courts[selectedState].courts
          ).map((court) => ({
            label: court.toUpperCase().replace("_", " "),
            value: courtValues.state_courts[selectedState].courts[court],
          }));
          return [...acc, ...courts];
        }
        return acc;
      }, []);

      setCourtIncludeOptions(options);
    }
    //else if (Number(values?.target?.value.join(","))) {
    //   setCourtIncludeOptions(null);
    // }
    //  else if (values?.target?.value.join(",").includes("courts")) {
    else if (courtByLaw === "federal_courts") {
      const federalOptions = values?.target?.value.reduce((acc, value) => {
        const courtsOpt = Number(values?.target?.value)
          ? null
          : values?.target?.value.split("-");

        if (courtsOpt) {
          const items = Object.keys(
            courtValues[courtByLaw][courtsOpt[0]][courtsOpt[1]]
          ).map((item) => ({
            label: item.toUpperCase().replace("_", " "),
            value: courtValues[courtByLaw][courtsOpt[0]][courtsOpt[1]][item],
          }));
          return [...acc, ...items];
        }
        return acc;
      }, []);

      setCourtIncludeOptions(federalOptions);
    }
  };

  //

  const handleCourtsToIncludeChange = (event) => {
    setCourtsToInclude(event.target.value);
  };

  // Reset to the first step every time the component mounts or remounts
  useEffect(() => {
    setActiveStep(0);
    
    if (localStorage.getItem("GetStarted")) {
      setActiveStep((prev) => prev + 1);
      var deserialize = JSON.parse(localStorage.getItem("GetStarted"));
      if (deserialize) {
        setCourtByLaw(deserialize?.courtByLaw);
        handleCourtByLawChangeWheStoreToLocalStorage(deserialize?.courtByLaw);
        setTitle(deserialize?.title);
        setUserQuery(deserialize?.userQuery);
        setSelectedCourt(deserialize?.selectedCourt);
        handleCourtChangeWhenStoreInLocalStorage(deserialize?.selectedCourt);
        setRepresent(deserialize?.represent);
        setCourtsToInclude(deserialize?.courtsToInclude);
    
        setLegalGroundsOrKeyArea(deserialize?.legalGroundsOrKeyArea);
        setIsObjectiveAnalysis(deserialize?.isObjectiveAnalysis);
      }
      
      const step0Data = localStorage.getItem("LegalAssistantStep1Response");
      if (step0Data != null && step0Data !== undefined && step0Data !== "undefined") {
        const step0LocalStorageData = JSON.parse(step0Data)?.data;
        setQuestions(Object.values(step0LocalStorageData?.additional_questions));
        setGetStartedEditorData(step0LocalStorageData?.cover_page + "<div style='width:100%; height:5px; border:4px solid #ccc;'></div>" + step0LocalStorageData?.table_of_content);  
  
        const subsequent_questions_Saved_Answers_json = localStorage.getItem("subsequent_questions_Saved_Answers");
  
        if (subsequent_questions_Saved_Answers_json) {
          setActiveStep((prev) => prev + 1);
          const subsequent_questions_Saved_Answers = JSON.parse(subsequent_questions_Saved_Answers_json);
          console.log(subsequent_questions_Saved_Answers,"sub"); 
          console.log(questions);
  
          // Only map over questions if they are valid (not null or undefined)
          if (Array.isArray(questions)) {
            questions.map((item, index) => {
              if (item) {  
                const subsequestParseQuestion = Object.keys(subsequent_questions_Saved_Answers);
                subsequestParseQuestion.forEach((element) => {
                  if (subsequent_questions_Saved_Answers[element] === item) {
                    const questionNo = element.match(/\d+/);
                    const key = "answer" + questionNo[0].toString();
                    setAnswers((prevAnswers) => ({
                      ...prevAnswers,
                      [item]: subsequent_questions_Saved_Answers[key],
                    }));
                  }
                });
              }
            });
          } else {
            console.warn("Questions are not in the correct format:", questions);
          }
        }
      }
  
      const relevant_cases = localStorage.getItem("relevant_cases");
      if (relevant_cases) {
        setRelevantCases(JSON.parse(relevant_cases));
      }
    }
  }, []);  // Run the effect when 'questions' state changes
  

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    ...theme.applyStyles("dark", {
      backgroundColor: "#1A2027",
    }),
  }));

  const isStepOptional = (step) => step === 1;
  const isStepSkipped = (step) => skipped.has(step);

  const handleNext = async () => {
    debugger;
    let newSkipped = skipped;

    // Check if the current step is skipped and update the skipped Set
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    // Check the current value of activeStep and make API calls accordingly
    if (activeStep === 0) {
      const formData = new FormData();
      formData.append("user_query", userQuery);

      if (title !== "" && userQuery !== "") {
        debugger;
        await axiosInstance
          .post(baseUrl + "Law/GetAdditionalQuestions", formData)
          .then((res) => {
            debugger;
            setActiveStep((prev) => prev + 1);
            const getStartedData = {
              title,
              userQuery,
              legalGroundsOrKeyArea,
              courtByLaw,
              selectedCourt,
              courtsToInclude,
              represent,
              isObjectiveAnalysis,
            };

            localStorage.setItem("GetStarted", JSON.stringify(getStartedData));
            localStorage.setItem(
              "LegalAssistantStep1Response",
              JSON.stringify(res?.data)
            );
            const step0Data = 
        localStorage.getItem("LegalAssistantStep1Response");
            if (step0Data != null && step0Data != undefined && step0Data != "undefined") {
              const step0LocalStorageData = JSON.parse(step0Data)?.data;
              setQuestions(Object.values(step0LocalStorageData?.additional_questions));
              setGetStartedEditorData(step0LocalStorageData?.cover_page + "<div style='width:100%; height:5px; border:4px solid #ccc;'></div>" + step0LocalStorageData?.table_of_content);  
            }
          }); // Replace with your API call function for step 0
      }

      // Move to the next step
    } else if (activeStep === 1) {
      console.log(answers);
      const formData = new FormData();
      formData.append("UserQuery", userQuery);
      const questionsWithAnswers = {};
      Object.keys(answers).forEach((item, index) => {
        questionsWithAnswers[`question${index + 1}`] = item; 
        questionsWithAnswers[`answer${index + 1}`] = answers[item]; 
      });

      formData.append(
        "QuestionWithAnswers",
        JSON.stringify(questionsWithAnswers)
      );

      await axiosInstance
        .post("https://localhost:7218/api/Law/GetModifiedUserQuery", formData)
        .then((res) => {
          debugger
          let prevStepData = JSON.parse(localStorage.getItem("GetStarted"));
          if (prevStepData) {
            prevStepData.userQuery = res?.data?.data?.user_query;
            localStorage.setItem("GetStarted",JSON.stringify(prevStepData));
            // Save Subsequent Question in localStorage
            localStorage.setItem("subsequent_questions_Saved_Answers",JSON.stringify(questionsWithAnswers))
            localStorage.setItem("subsequentQuestionsHtml",JSON.stringify(res?.data?.data?.subsequent_questions_html));
          }
        });

      // Move to the next step
      setActiveStep((prev) => prev + 1);

      // get_law_words
      const formDataLawKeyword = new FormData();
      formDataLawKeyword.append("UserQuery", userQuery);
      await axiosInstance.post(baseUrl + "Law/GetLawWords", formDataLawKeyword).then(res => {
        if (res) {
          localStorage.setItem("law_keywords",res?.data?.data?.law_keywords);
        }
      })

      formDataLawKeyword.append("StateCourts", "1,61,62,63");
      await axiosInstance.post(baseUrl + "Law/GetRelevantCasesTitlesCitationSummariesFast", formDataLawKeyword).then(res => {
        if (res) {
          localStorage.setItem("relevant_cases",JSON.stringify(res?.data?.data?.relevant_cases));
          setRelevantCases(res?.data?.data?.relevant_cases);
        }
      })
    }

    // Update skipped steps
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
    setSkipped(new Set());
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  // Function to render forms or content for each step
  // Step 1

  // Step 2
  const handleAnswerChange = (questionText, selectedOption) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionText]: selectedOption,
    }));
  };

  const handleCheckboxChange = (event, questionText) => {
    const checked = event.target.checked;
    setSelectedQuestions((prevSelected) => ({
      ...prevSelected,
      [questionText]: checked,
    }));
    // Clear answer if unchecked
    if (!checked) {
      setAnswers((prevAnswers) => ({
        ...prevAnswers,
        [questionText]: "",
        [`${questionText}_other`]: "",
      }));
    }
  };

  const handleDoubleClick = (index) => setEditingQuestion(index);

  const handleEditChange = (event, index) => {
    const updatedQuestions = [...questions];
    updatedQuestions[index] = event.target.value; // Update only the text of the specific question
    setQuestions(updatedQuestions); // Update the entire questions array
  };

  const handleEditBlur = () => setEditingQuestion(null);

  // Function to add a custom question
  const handleAddQuestion = () => {
    debugger;
    const newQuestion = `Enter your question`; // Default question text
    setQuestions((prevQuestions) => [
      ...prevQuestions,
      newQuestion, // Mark question as custom
    ]);
  };

  // Function to delete a custom question
  const handleDeleteQuestion = (index) => {
    const updatedQuestions = questions.filter(
      (_, i) => i !== index || !questions[i].isCustom // Only delete if it's a custom question
    );
    setQuestions(updatedQuestions);
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Box>
            {/* Get Started */}
            <Item>
              <Grid container spacing={2}>
                <Grid size={12}>
                  <div>
                    <h1
                      style={{
                        color: "#fff",
                        fontWeight: "900",
                        background: "#000",
                        padding: "10px",
                      }}
                    >
                      Legal Assistant
                    </h1>
                    <h1>
                      To get started, please complete all the necessary fields
                      in the form below.
                    </h1>
                    <p>
                      <strong>Disclaimer:</strong>
                      LEGAL-SEE is a productivity enhancer and not an attorney.
                      We may have responses that are incorrect. Nothing on this
                      platform is the legal advice.
                    </p>
                  </div>
                </Grid>
                <Grid size={12}>
                  <TextField
                    id="outlined"
                    label="Title"
                    placeholder="Write a title or leave empty"
                    fullWidth
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </Grid>

                <Grid size={12}>
                  <TextField
                    required
                    id="outlined-multiline-flexible"
                    label="Summary"
                    multiline
                    placeholder="Enter the summary of the case here, including all events, facts, involved parties, procedural history and cause of action."
                    maxRows={6}
                    rows={5}
                    margin="normal"
                    autoCorrect
                    focused
                    fullWidth
                    value={userQuery}
                    onChange={(e) => setUserQuery(e.target.value)}
                  />
                </Grid>

                <Grid size={12}>
                  <TextField
                    id="outlined"
                    label="Legal Grounds or Key Focus Areas (optional)"
                    placeholder="Tortious Interference"
                    fullWidth
                    value={legalGroundsOrKeyArea}
                    onChange={(e) => setLegalGroundsOrKeyArea(e.target.value)}
                  />
                </Grid>

                <Grid size={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Courts by Law
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={courtByLaw}
                      label="Courts by Law"
                      onChange={handleCourtByLawChange}
                      style={{ textAlign: "left" }}
                    >
                      {Object.keys(courtValues).map((item) => (
                        <MenuItem key={item} value={item}>
                          {item.toUpperCase().replace("_", " ")}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid size={6}>
                  <FormControl fullWidth>
                    <InputLabel id="most-relevant-jurisdiction-label">
                      Most Relevant Jurisdiction
                    </InputLabel>
                    <Select
                      labelId="most-relevant-jurisdiction-label"
                      id="court-select"
                      multiple
                      value={selectedCourt}
                      onChange={handleCourtChange}
                      renderValue={(selected) => {
                        return selected
                          .map((value) => {
                            const selectedOption = courtOptions.find(
                              (option) => option.value === value
                            );
                            return selectedOption
                              ? selectedOption.label
                              : value; // Fallback to value if not found
                          })
                          .join(", ");
                      }}
                      MenuProps={MenuProps}
                      input={
                        <OutlinedInput label="Most Relevant Jurisdiction" />
                      }
                      style={{ textAlign: "left" }}
                    >
                      {courtOptions.map((item) => (
                        <MenuItem
                          key={item.value}
                          value={item.value}
                          style={getStyles(item.value, selectedCourt, theme)}
                        >
                          <Checkbox
                            checked={selectedCourt.includes(item.value)}
                          />
                          <ListItemText primary={item.label} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid size={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Courts To Include
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={courtsToInclude}
                      label="Courts To Include"
                      onChange={handleCourtsToIncludeChange}
                      style={{ textAlign: "left" }}
                      multiple
                      renderValue={(selected) => {
                        return selected
                          .map((value) => {
                            const selectedOption = courtIncludeOptions.find(
                              (option) => option.value === value
                            );
                            return selectedOption
                              ? selectedOption.label
                              : value; // Fallback to value if not found
                          })
                          .join(", ");
                      }}
                      MenuProps={MenuProps}
                      input={<OutlinedInput label="Courts To Include" />}
                    >
                      {courtIncludeOptions.map((item) => (
                        <MenuItem
                          key={item.value}
                          value={item.value}
                          style={getStyles(item.value, courtsToInclude, theme)}
                        >
                          <Checkbox
                            checked={courtsToInclude.includes(item.value)}
                          />
                          <ListItemText primary={item.label} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid size={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      I Represent the...
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={represent}
                      label="I Represent the..."
                      onChange={(e) => setRepresent(e.target.value)}
                      style={{ textAlign: "left" }}
                    >
                      <MenuItem key={"Appellant"} value={"Appellant"}>
                        Appellant
                      </MenuItem>

                      <MenuItem key={"Defendant"} value={"Defendant"}>
                        Defendant
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid size={12} textAlign={"left"}>
                  <Checkbox
                    checked={isObjectiveAnalysis}
                    onChange={(e) => setIsObjectiveAnalysis(e.target.checked)}
                    inputProps={{ "aria-label": "controlled" }}
                  />{" "}
                  I want an objective analysis
                </Grid>
              </Grid>
            </Item>
          </Box>
        );
      case 1:
        return (
          <Box minWidth="100%">
            <Item minWidth="100%">
              <Grid container spacing={2} minWidth="100%">
                <Grid size={6} padding="15px">
                  <Grid size={12}>
                    <Box
                      sx={{
                        backgroundColor: "#1e1e2f",
                        padding: "30px",
                        borderRadius: "10px",
                        color: "#fff",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="h4"
                        gutterBottom
                        sx={{ fontWeight: 600 }}
                      >
                        Legal Research & Analysis
                      </Typography>
                    </Box>
                  </Grid>
                  {/*  */}
                  <Box
                    sx={{
                      minWidth: "100%",
                      marginTop: "20px",
                      width: "100%",
                      textAlign: "left",
                    }}
                  >
                    <Grid container spacing={3}>
                      {(questions && questions.length > 0) && questions.map((item, index) => (
                        <Grid
                          item
                          xs={12}
                          key={index}
                          style={{ width: "100%" }}
                        >
                          <Box
                            sx={{
                              backgroundColor: "#2c2f3b",
                              borderRadius: "8px",
                              padding: "20px",
                              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                              marginBottom: "20px", // Adding space between questions
                            }}
                          >
                            <Box
                              display="flex"
                              flexDirection="row"
                              alignItems="center"
                            >
                              <Checkbox
                                checked={selectedQuestions[item] || false}
                                onChange={(event) =>
                                  handleCheckboxChange(event, item)
                                }
                                sx={{
                                  color: "#FFBF00",
                                  "&.Mui-checked": {
                                    color: "#FFBF00",
                                  },
                                }}
                              />
                            </Box>

                            <Box sx={{ marginLeft: "43px" }}>
                              <Tooltip
                                title="Double-click to modify this question"
                                arrow
                              >
                                {editingQuestion === index ? (
                                  <TextField
                                    fullWidth
                                    value={item}
                                    onChange={(event) =>
                                      handleEditChange(event, index)
                                    }
                                    onBlur={handleEditBlur}
                                    autoFocus
                                    sx={{
                                      backgroundColor: "#fff",
                                      borderRadius: "5px",
                                      padding: "8px",
                                      marginTop: "8px",
                                    }}
                                  />
                                ) : (
                                  <Typography
                                    variant="h6"
                                    onDoubleClick={() =>
                                      handleDoubleClick(index)
                                    }
                                    sx={{
                                      color: "#fff",
                                      fontWeight: "500",
                                      marginTop: "-38px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Question {index + 1}: {item}
                                  </Typography>
                                )}
                              </Tooltip>
                            </Box>

                            {/* Delete button for custom questions */}
                            {editingQuestion !== index && item.isCustom && (
                              <IconButton
                                color="error"
                                onClick={() => handleDeleteQuestion(index)}
                                sx={{
                                  marginTop: "10px",
                                  color: "#FF5252",
                                  "&:hover": {
                                    color: "#D32F2F",
                                  },
                                }}
                              >
                                <DeleteIcon /> DELETE
                              </IconButton>
                            )}

                            <TextField
                                  placeholder="Please Enter your answer"
                                  multiline
                                  fullWidth
                                  name={item}
                                  value={answers[item] || ""}
                                  disabled={!selectedQuestions[item]}
                                  onChange={(event) =>
                                    handleAnswerChange(item, event.target.value)
                                  }
                                  sx={{
                                    backgroundColor: "#fff",
                                    borderRadius: "5px",
                                    padding: "10px",
                                    marginTop: "8px",
                                  }}
                                />
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                  {/*  */}
                  <Divider sx={{ margin: "30px 0" }} />

                  {/* Add button to add a new question */}
                  <Box
                    sx={{
                      margin: "15px 0",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      size="small"
                      onClick={handleAddQuestion}
                      sx={{
                        backgroundColor: "#FFBF00",
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: "#FF8000",
                        },
                      }}
                    >
                      <AddCircleIcon />
                      &nbsp; Add Question
                    </Button>
                  </Box>
                </Grid>

                <Grid size={6} padding="15px">
                  <Editor
                    editorsData={getStartedEditorData}
                    handleEditor={handleData}
                  />
                </Grid>
              </Grid>
            </Item>
          </Box>
        );
      case 2:
        return (
          <Box minWidth="100%">
            <Item minWidth="100%">
              <Grid container spacing={2} minWidth="100%">
                <Grid size={6} padding="15px">
                  <Grid size={12}>
                    <Box
                      sx={{
                        backgroundColor: "#1e1e2f",
                        padding: "30px",
                        borderRadius: "10px",
                        color: "#fff",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="h4"
                        gutterBottom
                        sx={{ fontWeight: 600 }}
                      >
                        Legal Research & Analysis
                      </Typography>
                    </Box>
                  </Grid>
                  
                  {/*  */}
                  <Grid container spacing={2} marginTop="12px">
                  <Grid size={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Courts by Law
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={courtByLaw}
                      label="Courts by Law"
                      onChange={handleCourtByLawChange}
                      style={{ textAlign: "left" }}
                    >
                      {Object.keys(courtValues).map((item) => (
                        <MenuItem key={item} value={item}>
                          {item.toUpperCase().replace("_", " ")}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid size={6}>
                  <FormControl fullWidth>
                    <InputLabel id="most-relevant-jurisdiction-label">
                      Most Relevant Jurisdiction
                    </InputLabel>
                    <Select
                      labelId="most-relevant-jurisdiction-label"
                      id="court-select"
                      multiple
                      value={selectedCourt}
                      onChange={handleCourtChange}
                      renderValue={(selected) => {
                        return selected
                          .map((value) => {
                            const selectedOption = courtOptions.find(
                              (option) => option.value === value
                            );
                            return selectedOption
                              ? selectedOption.label
                              : value; // Fallback to value if not found
                          })
                          .join(", ");
                      }}
                      MenuProps={MenuProps}
                      input={
                        <OutlinedInput label="Most Relevant Jurisdiction" />
                      }
                      style={{ textAlign: "left" }}
                    >
                      {courtOptions.map((item) => (
                        <MenuItem
                          key={item.value}
                          value={item.value}
                          style={getStyles(item.value, selectedCourt, theme)}
                        >
                          <Checkbox
                            checked={selectedCourt.includes(item.value)}
                          />
                          <ListItemText primary={item.label} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid size={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Courts To Include
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={courtsToInclude}
                      label="Courts To Include"
                      onChange={handleCourtsToIncludeChange}
                      style={{ textAlign: "left" }}
                      multiple
                      renderValue={(selected) => {
                        return selected
                          .map((value) => {
                            const selectedOption = courtIncludeOptions.find(
                              (option) => option.value === value
                            );
                            return selectedOption
                              ? selectedOption.label
                              : value; // Fallback to value if not found
                          })
                          .join(", ");
                      }}
                      MenuProps={MenuProps}
                      input={<OutlinedInput label="Courts To Include" />}
                    >
                      {courtIncludeOptions.map((item) => (
                        <MenuItem
                          key={item.value}
                          value={item.value}
                          style={getStyles(item.value, courtsToInclude, theme)}
                        >
                          <Checkbox
                            checked={courtsToInclude.includes(item.value)}
                          />
                          <ListItemText primary={item.label} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid size={6} display="flex" alignItems="center" justifyContent="end">

                <Button variant="contained">Apply</Button>
                </Grid>
                </Grid>
                  {/*  */}

                  {/*  */}
                  <Box
    sx={{
      minWidth: "100%",
      marginTop: "20px",
      width: "100%",
      textAlign: "left",
    }}
  >
    <Grid container spacing={3}>
      {/* Map through relevantCases and render each case */}
      {Object.keys(relevantCases).map((caseKey, index) => {
        const caseDetails = relevantCases[caseKey];
        return (
          <Grid item xs={12} key={index} style={{ width: "100%" }}>
            <Box
              sx={{
                backgroundColor: "#2c2f3b",
                borderRadius: "8px",
                padding: "20px",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                marginBottom: "20px", // Adding space between cases
              }}
            >
              <Box display="flex" flexDirection="row" alignItems="center" color="#fff">
                <Checkbox
                  sx={{
                    color: "#FFBF00",
                    "&.Mui-checked": {
                      color: "#FFBF00",
                    },
                  }}
                />
                {caseDetails.title}
              </Box>

              <Box sx={{ marginLeft: "43px", color: "#fff" }}>
                {caseDetails.summary}
              </Box>

              <Grid
                size={12}
                display="flex"
                alignItems="center"
                justifyContent="start"
                marginTop="7px"
              >
                <Button
                  variant="contained"
                  onClick={() => window.open(caseDetails.url, "_blank")}
                >
                  Preview
                </Button>
              </Grid>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  </Box>
                  {/*  */}
                </Grid>

                <Grid size={6} padding="15px">
                  <Editor
                    editorsData={getStartedEditorData}
                    handleEditor={handleData}
                  />
                </Grid>
              </Grid>
            </Item>
          </Box>
        );
      case 3:
        return (
          <Box minWidth="100%">
            <Item minWidth="100%">
              <Grid container spacing={2} minWidth="100%">
                <Grid size={6} padding="15px">
                  <Grid size={12}>
                    <Box
                      sx={{
                        backgroundColor: "#1e1e2f",
                        padding: "30px",
                        borderRadius: "10px",
                        color: "#fff",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="h4"
                        gutterBottom
                        sx={{ fontWeight: 600 }}
                      >
                        Legal Research & Analysis
                      </Typography>
                    </Box>
                  </Grid>
                
                  <Box
                    sx={{
                      minWidth: "100%",
                      marginTop: "20px",
                      width: "100%",
                      textAlign: "left",
                    }}
                  >
                    <Grid container spacing={3}>
                        <Grid
                          item
                          xs={12}
                          // key={index}
                          style={{ width: "100%" }}
                        >
                          <Box
                            sx={{
                              backgroundColor: "#2c2f3b",
                              borderRadius: "8px",
                              padding: "20px",
                              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                              marginBottom: "20px", // Adding space between questions
                            }}
                          >
                            <Box
                              display="flex"
                              flexDirection="row"
                              alignItems="center"
                              color="#fff"
                            >
                              <Checkbox
                                sx={{
                                  color: "#FFBF00",
                                  "&.Mui-checked": {
                                    color: "#FFBF00",
                                  },
                                }}
                              /> Boshell v. Keith
                            </Box>

                            <Box sx={{ marginLeft: "43px",color:"#fff" }}>
                            … Indeed, counsel for Appellants stated to this Court that, but for his inability to fully discover the records and files … When an appellant fails to argue an issue in its brief, that issue is waived …
                            </Box>

                            <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                              <Button variant="contained">Preview</Button>
                            </Grid>
                          </Box>
                        </Grid>
                    </Grid>
                  </Box>
                  {/*  */}
                </Grid>

                <Grid size={6} padding="15px">
                  <Editor
                    editorsData={getStartedEditorData}
                    handleEditor={handleData}
                  />
                </Grid>
              </Grid>
            </Item>
          </Box>
        );
      case 4:
        return (
          <Box minWidth="100%">
            <Item minWidth="100%">
              <Grid container spacing={2} minWidth="100%">
                <Grid size={6} padding="15px">
                  <Grid size={12}>
                    <Box
                      sx={{
                        backgroundColor: "#1e1e2f",
                        padding: "30px",
                        borderRadius: "10px",
                        color: "#fff",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="h4"
                        gutterBottom
                        sx={{ fontWeight: 600 }}
                      >
                        Legal Research & Analysis
                      </Typography>
                    </Box>
                  </Grid>
                
                  <Box
                    sx={{
                      minWidth: "100%",
                      marginTop: "20px",
                      width: "100%",
                      textAlign: "left",
                    }}
                  >
                    <Grid container spacing={3}>
                        <Grid
                          item
                          xs={12}
                          // key={index}
                          style={{ width: "100%" }}
                        >
                          <Box
                            sx={{
                              backgroundColor: "#2c2f3b",
                              borderRadius: "8px",
                              padding: "20px",
                              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                              marginBottom: "20px", // Adding space between questions
                            }}
                          >
                            <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                              <Button variant="contained" id="cover_page">Cover Page</Button>
                            </Grid>
                          </Box>

                          <Box
                            sx={{
                              backgroundColor: "#2c2f3b",
                              borderRadius: "8px",
                              padding: "20px",
                              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                              marginBottom: "20px", // Adding space between questions
                            }}
                          >
                            <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                              <Button variant="contained" id="table_of_content">Table of Contents</Button>
                            </Grid>
                          </Box>

                          <Box
                            sx={{
                              backgroundColor: "#2c2f3b",
                              borderRadius: "8px",
                              padding: "20px",
                              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                              marginBottom: "20px", // Adding space between questions
                            }}
                          >
                            <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                              <Button variant="contained">Question Presented</Button>
                            </Grid>
                          </Box>

                          <Box
                            sx={{
                              backgroundColor: "#2c2f3b",
                              borderRadius: "8px",
                              padding: "20px",
                              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                              marginBottom: "20px", // Adding space between questions
                            }}
                          >
                            <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                              <Button variant="contained">Table of Authorities</Button>
                            </Grid>
                          </Box>

                          <Box
                            sx={{
                              backgroundColor: "#2c2f3b",
                              borderRadius: "8px",
                              padding: "20px",
                              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                              marginBottom: "20px", // Adding space between questions
                            }}
                          >
                            <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                              <Button variant="contained">Statement of Case</Button>
                            </Grid>
                          </Box>

                        </Grid>
                    </Grid>
                  </Box>
                  {/*  */}
                </Grid>

                <Grid size={6} padding="15px">
                  <Editor
                    editorsData={getStartedEditorData}
                    handleEditor={handleData}
                  />
                </Grid>
              </Grid>
            </Item>
          </Box>
        );
      case 5:
        return (
          <Box minWidth="100%">
          <Item minWidth="100%">
            <Grid container spacing={2} minWidth="100%">
              <Grid size={6} padding="15px">
                <Grid size={12}>
                  <Box
                    sx={{
                      backgroundColor: "#1e1e2f",
                      padding: "30px",
                      borderRadius: "10px",
                      color: "#fff",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      variant="h4"
                      gutterBottom
                      sx={{ fontWeight: 600 }}
                    >
                      Legal Research & Analysis
                    </Typography>
                  </Box>
                </Grid>
              
                <Box
                  sx={{
                    minWidth: "100%",
                    marginTop: "20px",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  <Grid container spacing={3}>
                      <Grid
                        item
                        xs={12}
                        // key={index}
                        style={{ width: "100%" }}
                      >
                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Cover Page</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Table of Contents</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Question Presented</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Table of Authorities</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Statement of Case</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Summary of Argument</Button>
                          </Grid>
                        </Box>

                      </Grid>
                  </Grid>
                </Box>
                {/*  */}
              </Grid>

              <Grid size={6} padding="15px">
                <Editor
                  editorsData={getStartedEditorData}
                  handleEditor={handleData}
                />
              </Grid>
            </Grid>
          </Item>
        </Box>
        );
      case 6:
        return (
          <Box minWidth="100%">
          <Item minWidth="100%">
            <Grid container spacing={2} minWidth="100%">
              <Grid size={6} padding="15px">
                <Grid size={12}>
                  <Box
                    sx={{
                      backgroundColor: "#1e1e2f",
                      padding: "30px",
                      borderRadius: "10px",
                      color: "#fff",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      variant="h4"
                      gutterBottom
                      sx={{ fontWeight: 600 }}
                    >
                      Legal Research & Analysis
                    </Typography>
                  </Box>
                </Grid>
              
                <Box
                  sx={{
                    minWidth: "100%",
                    marginTop: "20px",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  <Grid container spacing={3}>
                      <Grid
                        item
                        xs={12}
                        // key={index}
                        style={{ width: "100%" }}
                      >
                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Cover Page</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Table of Contents</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Question Presented</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Table of Authorities</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Statement of Case</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Summary of Argument</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Argument</Button>
                          </Grid>
                        </Box>

                      </Grid>
                  </Grid>
                </Box>
                {/*  */}
              </Grid>

              <Grid size={6} padding="15px">
                <Editor
                  editorsData={getStartedEditorData}
                  handleEditor={handleData}
                />
              </Grid>
            </Grid>
          </Item>
        </Box>
        );
      case 7:
        return (
          <Box minWidth="100%">
          <Item minWidth="100%">
            <Grid container spacing={2} minWidth="100%">
              <Grid size={6} padding="15px">
                <Grid size={12}>
                  <Box
                    sx={{
                      backgroundColor: "#1e1e2f",
                      padding: "30px",
                      borderRadius: "10px",
                      color: "#fff",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      variant="h4"
                      gutterBottom
                      sx={{ fontWeight: 600 }}
                    >
                      Legal Research & Analysis
                    </Typography>
                  </Box>
                </Grid>
              
                <Box
                  sx={{
                    minWidth: "100%",
                    marginTop: "20px",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  <Grid container spacing={3}>
                      <Grid
                        item
                        xs={12}
                        // key={index}
                        style={{ width: "100%" }}
                      >
                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Cover Page</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Table of Contents</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Question Presented</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Table of Authorities</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Statement of Case</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Summary of Argument</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Argument</Button>
                          </Grid>
                        </Box>

                        <Box
                          sx={{
                            backgroundColor: "#2c2f3b",
                            borderRadius: "8px",
                            padding: "20px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            marginBottom: "20px", // Adding space between questions
                          }}
                        >
                          <Grid size={12} display="flex" alignItems="center" justifyContent="start" marginTop="7px">
                            <Button variant="contained">Conclusion</Button>
                          </Grid>
                        </Box>

                      </Grid>
                  </Grid>
                </Box>
                {/*  */}
              </Grid>

              <Grid size={6} padding="15px">
                <Editor
                  editorsData={getStartedEditorData}
                  handleEditor={handleData}
                />
              </Grid>
            </Grid>
          </Item>
        </Box>
        );
      default:
        return <Typography variant="h6">Unknown Step</Typography>;
    }
  };

  return (
    <Box sx={{ minWidth: "100%", maxWidth: "100%", overflowX: "scroll" }}>
      <Stepper activeStep={activeStep} sx={{ mb: 3 }}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          if (isStepOptional(index)) {
            labelProps.optional = (
              <Typography variant="caption">Optional</Typography>
            );
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps} onClick={handleStep(index)}>
                {label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === steps.length ? (
        <React.Fragment>
          <Typography sx={{ mt: 2, mb: 1 }}>
            All steps completed - you're finished.
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Box sx={{ flex: "1 1 auto" }} />
            <Button onClick={handleReset}>Reset</Button>
          </Box>
        </React.Fragment>
      ) : (
        <React.Fragment>
          {renderStepContent(activeStep)}
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Button
              color="inherit"
              disabled={activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>
            <Box sx={{ flex: "1 1 auto" }} />
            <Button onClick={handleNext}>
              {activeStep === steps.length - 1 ? "Finish" : "Next"}
            </Button>
          </Box>
        </React.Fragment>
      )}
    </Box>
  );
}

export default LegalAssistant;
